// From https://developer.mozilla.org/en-US/docs/Web/Reference/Events/wheel?redirectlocale=en-US&redirectslug=DOM%2FMozilla_event_reference%2Fwheel

// creates a global "addWheelListener" method
// example: addWheelListener( elem, function( e ) { console.log( e.deltaY ); e.preventDefault(); } );
(function(window,document) {

    var prefix = "", _addEventListener, onwheel, support;

    var stats = {
        max : null,
        min : null,
        factor: 1
    };

    function normalize(delta) {
        var absDelta = Math.abs(delta);

        // store the min value
        if (stats.min == null || stats.min > absDelta) {
          stats.min = absDelta;
          recalculateMultiplicator();
        }

        // store the max value
        if (stats.max == null || stats.max < absDelta) {
          stats.max = absDelta;
          recalculateMultiplicator();
        }

        // special case for systems not speeding up
        if (stats.max === absDelta && stats.min === absDelta) {
          return 2 * (delta / absDelta);
        }

        var range = stats.max - stats.min;
        var ret = (delta / range) * Math.log(range) * stats.factor;

        // return at least 1 or -1
        return ret < 0 ? Math.min(ret, -1) : Math.max(ret, 1);
    }


      /**
       * Recalculates the factor with which the calculated delta is normalized.
       */
    function recalculateMultiplicator() {
        var max = stats.max || 0;
        var min = stats.min || max;
        if (max <= min) {
          return;
        }
        var range = max - min;
        var maxRet = (max / range) * Math.log(range);
        if (maxRet == 0) {
          maxRet = 1;
        }
        stats.factor = 6 / maxRet;
    }


    // detect event model
    if ( window.addEventListener ) {
        _addEventListener = "addEventListener";
    } else {
        _addEventListener = "attachEvent";
        prefix = "on";
    }

    // detect available wheel event
    support = "onwheel" in document.createElement("div") ? "wheel" : // Modern browsers support "wheel"
              document.onmousewheel !== undefined ? "mousewheel" : // Webkit and IE support at least "mousewheel"
              "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox

    window.addWheelListener = function( elem, callback, useCapture ) {
        _addWheelListener( elem, support, callback, useCapture );

        // handle MozMousePixelScroll in older Firefox
        if( support == "DOMMouseScroll" ) {
            _addWheelListener( elem, "MozMousePixelScroll", callback, useCapture );
        }
    };

    function _addWheelListener( elem, eventName, callback, useCapture ) {
        elem[ _addEventListener ]( prefix + eventName, support == "wheel" ? callback : function( originalEvent ) {
            !originalEvent && ( originalEvent = window.event );

            // create a normalized event object
            var event = {
                // keep a ref to the original event object
                originalEvent: originalEvent,
                target: originalEvent.target || originalEvent.srcElement,
                type: "wheel",
                deltaMode: originalEvent.type == "MozMousePixelScroll" ? 0 : 1,
                deltaX: 0,
                delatZ: 0,
                preventDefault: function() {
                    originalEvent.preventDefault ?
                        originalEvent.preventDefault() :
                        originalEvent.returnValue = false;
                }
            };

            // calculate deltaY (and deltaX) according to the event
            if ( support == "mousewheel" ) {
                event.deltaY = - 1/40 * originalEvent.wheelDelta;
                // Webkit also support wheelDeltaX
                originalEvent.wheelDeltaX && ( event.deltaX = - 1/40 * originalEvent.wheelDeltaX );
            } else {
                event.deltaY = originalEvent.detail;
            }

            //event.delta = normalize(event.delta);
            event.deltaX = normalize(event.deltaX);
            event.deltaY = normalize(event.deltaY);

            // it's time to fire the callback
            return callback( event );

        }, useCapture || false );
    }

})(window,document);